var _path, _path2, _rect, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraPermission4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 145,
    viewBox: "0 0 136 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.125 88.4375C61.125 92.6142 64.5108 96 68.6875 96C72.8642 96 76.25 92.6142 76.25 88.4375V54.5938C76.25 41.5791 65.6664 31 52.6562 31C39.6461 31 29.0625 41.5791 29.0625 54.5938V56.8125C29.0625 60.9892 32.4483 64.375 36.625 64.375C40.8017 64.375 44.1875 60.9892 44.1875 56.8125V54.5938C44.1875 49.9273 47.9898 46.125 52.6562 46.125C57.3227 46.125 61.125 49.9273 61.125 54.5938V88.4375ZM90.4508 89.3817C89.8972 92.0705 87.5301 94 84.7848 94C81.59 94 79 91.41 79 88.2152V83.2869C79 79.8147 81.8147 77 85.2869 77C89.2687 77 92.2476 80.6546 91.4446 84.5547L90.4508 89.3817ZM51.2152 94C48.4699 94 46.1028 92.0705 45.5492 89.3817L44.5554 84.5547C43.7524 80.6546 46.7313 77 50.7131 77C54.1853 77 57 79.8147 57 83.2869V88.2152C57 91.41 54.41 94 51.2152 94Z",
    fill: "url(#paint0_linear_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3983 99.5921C17.0263 93.7868 21.8076 88 28.0788 88H108.921C115.192 88 119.974 93.7868 117.602 99.5921C99.9455 142.803 37.0544 142.803 19.3983 99.5921Z",
    fill: "url(#paint1_linear_4)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 49,
    width: 118,
    height: 18,
    rx: 9,
    fill: "#00F0FF",
    fillOpacity: 0.62
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7426 6.12231H18C11.3726 6.12231 6 11.4949 6 18.1223V22.8649",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130 22.8649L130 18.1223C130 11.4949 124.627 6.12231 118 6.12231L113.257 6.12231",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.257 138.494L118 138.494C124.627 138.494 130 133.121 130 126.494L130 121.751",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 121.751L6 126.494C6 133.121 11.3726 138.494 18 138.494L22.7426 138.494",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4",
    x1: 36,
    y1: 41.5,
    x2: 92,
    y2: 78.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6473F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4",
    x1: 16,
    y1: 87.5535,
    x2: 120.709,
    y2: 87.5535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38D8CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1792B9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPermission4);
export default __webpack_public_path__ + "static/media/camera_permission_4.7c37c13b.svg";
export { ForwardRef as ReactComponent };